import { Typography } from 'antd'
import styled from 'styled-components'

const { Text } = Typography

export const StyledLabel = styled(Text)`
  font-size: 12px;
`
